import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { useEffect, useState } from 'react';
import { MessageAvatar } from './MessageAvatar';
const loadingMessages = [
    'Turning acronyms into answers',
    'A little less paperwork, a little more clarity',
    'Keeping the mission in view',
    'Making room for the fine print',
    'Good briefings take a little thought',
    'From contract complexity to a clear next step'
];
/** Rotating GovCon copy with a stable logo and a separate elapsed-time line. */ export function WhimsicalLoadingIndicator({ customMessages, variant = 'default' } = {}) {
    const [seconds, setSeconds] = useState(0);
    useEffect(()=>{
        const start = Date.now();
        const interval = setInterval(()=>setSeconds(Math.floor((Date.now() - start) / 1000)), 1000);
        return ()=>clearInterval(interval);
    }, []);
    const messages = [
        ...customMessages?.length ? customMessages : [
            'Working through your request'
        ],
        ...loadingMessages
    ];
    const message = messages[Math.floor(seconds / 4) % messages.length];
    return /*#__PURE__*/ _jsxs("output", {
        className: `flex items-start ${variant === 'assist' ? 'gap-[9px]' : 'gap-3'}`,
        "data-testid": Testids.assistant.loadingIndicator,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "motion-safe:animate-pulse",
                children: /*#__PURE__*/ _jsx(MessageAvatar, {
                    isAssistant: true,
                    variant: variant === 'assist' ? 'assist' : 'default'
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 pt-1 text-sm text-muted-foreground",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        "data-testid": Testids.assistant.loadingCopy,
                        className: "chat-loading-glimmer",
                        children: [
                            message,
                            "…"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        "data-testid": Testids.assistant.loadingElapsed,
                        className: "mt-1 text-xs tabular-nums",
                        children: [
                            seconds,
                            "s elapsed"
                        ]
                    }),
                    seconds >= 30 && /*#__PURE__*/ _jsx("p", {
                        className: "mt-1 text-xs",
                        children: "Still preparing your response. You can keep this conversation open."
                    })
                ]
            })
        ]
    });
}
